import {combineReducers} from 'redux';
import { routerReducer } from 'react-router-redux';
import counter from './counter';
import user from './userReducer';
import ToolkitReducer from './ToolkitReducer';
import verify from './verifyReducer';
import registration from './registration';
import challengeStatement from './challengeStatementReducer';
import influencerMap from './InfluencerMapReducer';
import benefitsLadderReducer from './benefitsLadderReducer';
import competitiveAnalysisReducer from './competitiveAnalysisReducer';
import segmentationReducer from './segmentationReducer';
import segmentAttractivenessReducer from './segmentAttractivenessReducer';
import abilityToCompeteReducer from './abilityToCompeteReducer';
import prioritizerReducer from './prioritizerReducer';
import differentialAdvantage from './differentialAdvantageReducer';
import positioningStatement from './positioningStatementReducer';
import valueProposition from './valuePropositionReducer';
import pricingValue from './pricingValueReducer';

const stores = combineReducers({
    router: routerReducer,
    counter,
    user,
    ToolkitReducer,
    verify,
    registration,
    challengeStatement,
    influencerMap,
    benefits: benefitsLadderReducer,
    competitiveAnalysis: competitiveAnalysisReducer,
    segmentation:  segmentationReducer,
    segmentAttractivenessReducer: segmentAttractivenessReducer,
    compete: abilityToCompeteReducer,
    prioritizer: prioritizerReducer,
    differentialAdvantage: differentialAdvantage,
    positioningStatement: positioningStatement,
    valueProposition,
    pricingValue
});

export default stores;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js